export default __webpack_public_path__ + "static/media/cloudy.1cdece9b.svg";